/**
 * /g/:sessionId — session-share landing page (digital mode).
 *
 * v1 behavior: redirect to the studio's existing public gallery
 * (`dreamboothstudio.com/gallery/{sessionId}`). That page already
 * handles magic-link auth, the native share button, and presigned
 * download URLs. See `docs/digital-mode-plan.md` §4.3.
 *
 * Replace with a renderer-native gallery view in Phase C if a
 * visually-unified `dreambooth.app/g/...` is desired.
 */

import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { resolveGallerySessionUrlFromStore } from '../utils/galleryUrlUtils'

const SessionRedirect: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>()

  useEffect(() => {
    if (!sessionId) return
    // One resolver for every shareable gallery link (QR, share sheet, WhatsApp,
    // Open gallery, and this landing page), in kiosk and digital alike. It is
    // deliberately the studio's absolute URL: a same-host `/gallery/*` proxy
    // lands the visitor on this SPA's shell instead of their photos — see
    // utils/galleryUrlUtils.ts for the locale-redirect reason.
    window.location.replace(resolveGallerySessionUrlFromStore(sessionId))
  }, [sessionId])

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        color: '#666'
      }}
    >
      <p>Opening gallery&hellip;</p>
    </main>
  )
}

export default SessionRedirect
